export class Features {
    http;
    constructor(http) {
        this.http = http;
    }
    getFeaturesCount({ coordinates }) {
        return this.http.get(`/api/features/count/?coordinates=${coordinates[0]},${coordinates[1]}`).json();
    }
}
